import { render, staticRenderFns } from "./AppVersion.vue?vue&type=template&id=7c5dc9c8&"
import script from "./AppVersion.vue?vue&type=script&lang=js&"
export * from "./AppVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports